import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { BrowseDataAPIFilter } from 'src/services/browse-data-api/types/BrowseDataAPIFilter';

export const adaptBrowseFilters = (browseFilters: BrowseDataAPIFilter[]): Facet[] => {
  return browseFilters.map((filter) => {
    const { defaultOption, expandedByDefault, ...restOfFilter } = filter;

    return {
      ...restOfFilter,
      options: filter.options.map((option) => {
        const { tooltip, ...restOfOption } = option;

        return {
          ...restOfOption,
          minValue: option.minValue ?? null,
          maxValue: option.maxValue ?? null,
        };
      }),
    };
  });
};
